/**
 * InviterBadge Component
 * "Invited by" card used across invite-style signup flows.
 * Care-Seeker passes `secondary` as a company name; Sub-Delegate passes it as a role label.
 */

export type InviterBadgeProps = {
  name?: string;
  secondary?: string;
  permissions?: string[];
};

export const InviterBadge = ({
  name,
  secondary,
  permissions,
}: InviterBadgeProps) => (
  <div className="mb-8 rounded-3xl bg-white/15 p-5">
    <p className="font-termina text-white/80 text-sm">Invited by</p>
    {name && (
      <p className="font-termina text-white font-bold text-lg">{name}</p>
    )}
    {secondary && (
      <p className="font-termina text-white/80 text-sm">{secondary}</p>
    )}
    {permissions && permissions.length > 0 && (
      <p className="font-termina text-white/80 text-sm mt-2">
        <span className="font-bold">Permissions:</span> {permissions.join(', ')}
      </p>
    )}
  </div>
);
